import { TOUR_DEFAULT_PLACEMENT } from "../constants/tour";
import { TOUR_TARGETS, tourSelector } from "../constants/tourTargets";

// Ordered tour content. Nothing on this page has to be carried out before the
// tour will move on, so no stop carries a requirement. isAvailable drops a stop
// whose anchor this account never renders. The sample row anchors three of them
// and is on the page for as long as the tour can run, so those always resolve.
const CASE_LIST_TOUR_STOPS = [
   {
      target: TOUR_TARGETS.CASE_LIST_SAMPLE_ROW,
      title: "A sample case, for the tour only",
      content:
         "This row is not one of yours. It is here so the tour always has a case to point at, and it goes when the tour does. A real row reads the same way: case name, type and date of incident, then the plaintiffs and defendants, then when it was last touched.",
      placement: "bottom",
   },
   {
      target: TOUR_TARGETS.CASE_LIST_SAMPLE_STATUS,
      title: "How far along the demand is",
      content:
         "The ring fills as we work through the case and sits at 100% once the demand is drafted. A case you have not generated yet says draft instead, and a failed run turns the ring red.",
   },
   {
      target: TOUR_TARGETS.CASE_LIST_SAMPLE_ACTIONS,
      title: "Everything you can do to a case",
      content:
         "Edit Case reopens the wizard, Downloads holds the letter and its exhibits, and Overview is the settlement summary. Anything that needs a drafted demand stays out of reach until you have one.",
   },
   {
      target: TOUR_TARGETS.CASE_LIST_SEARCH,
      title: "Finding a case again",
      content:
         "Searches case names and parties, and the case id if you paste one in. Following a notification lands you here with the search already filled in, which is why it is sometimes not empty.",
      placement: "bottom",
   },
   {
      target: TOUR_TARGETS.CASE_LIST_MY_CASES,
      title: "Yours, or the whole firm",
      content:
         "Off shows every case your team can see. On narrows it to the ones you created. We remember which way you left it.",
      placement: "bottom",
   },
   {
      target: TOUR_TARGETS.CASE_LIST_ADD_CASE,
      title: "Start a real one",
      content:
         "This creates an empty case and takes you into the wizard, where a second tour walks you through the five steps to a demand.",
      isAvailable: ({ hasAddCase }) => hasAddCase,
      placement: "bottom",
   },
];

// The stops this account actually renders, in the order the tour visits them
export const getCaseListTourStops = ({ hasAddCase }) =>
   CASE_LIST_TOUR_STOPS.filter(({ isAvailable }) => !isAvailable || isAvailable({ hasAddCase }));

export const buildCaseListTourSteps = ({ hasAddCase }) =>
   getCaseListTourStops({ hasAddCase }).map(({ target, title, content, placement }) => ({
      target: tourSelector(target),
      title,
      content,
      placement: placement ?? TOUR_DEFAULT_PLACEMENT,
   }));

export default CASE_LIST_TOUR_STOPS;
